import React from 'react';
import { FlexContainer, SkeletonBlock } from '../styles';

export const OpeningHourBlock = (): JSX.Element => {
  return (
    <FlexContainer gap="25">
      <SkeletonBlock width="66" />
      <SkeletonBlock width="349" />
    </FlexContainer>
  );
};
